import SelectTree from './src/index'

SelectTree.install = function (Vue) {
  Vue.component(SelectTree.name, SelectTree)
}

export default SelectTree
